import API from 'js/lib/api';

export default API('/api/onDemandSessions.v1/', {
  type: 'rest',
});
